import React from 'react';
import './StyledButton.css';

/**
 * StyledButton — Standardized button component
 * 
 * @param {'primary'|'secondary'|'danger'|'ghost'|'icon'} variant
 * @param {'sm'|'md'|'lg'} size
 * @param {boolean} fullWidth
 * @param {boolean} loading
 * @param {boolean} disabled
 * @param {React.ReactNode} startIcon
 * @param {React.ReactNode} endIcon
 * @param {React.ReactNode} children
 */
const StyledButton = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  disabled = false,
  startIcon,
  endIcon,
  children,
  className = '',
  ...props
}) => {
  const classes = [
    'ck-btn',
    `ck-btn--${variant}`,
    `ck-btn--${size}`,
    fullWidth && 'ck-btn--full',
    loading && 'ck-btn--loading',
    disabled && 'ck-btn--disabled',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className="ck-btn-spinner" />}
      {!loading && startIcon && <span className="ck-btn-icon ck-btn-icon--start">{startIcon}</span>}
      {children && <span className="ck-btn-label">{children}</span>}
      {!loading && endIcon && <span className="ck-btn-icon ck-btn-icon--end">{endIcon}</span>}
    </button>
  );
};

export default StyledButton;
